import { TReaderDocument } from '@app-evolution-cms/email-builder';

import { EMAIL_COLOR } from './editor-email/constants/colors';
import { FONT_FAMILY_ITEM } from './editor-email/constants/font-family';

export const EMPTY_LAYOUT: TReaderDocument = {
  root: {
    type: 'EmailLayout',
    data: {
      backdropColor: 'transparent',
      borderRadius: 0,
      canvasColor: EMAIL_COLOR.primaryInverted,
      textColor: EMAIL_COLOR.primary,
      fontFamily: FONT_FAMILY_ITEM.modernSans,
      childrenIds: [],
    },
  },
};
